module.exports = __webpack_public_path__ + "img/7.66f5369f.png";